import { ReactNode } from 'react'
import { Popover, Button, Flex } from '@radix-ui/themes'
import { MixerHorizontalIcon } from '@radix-ui/react-icons'
import { useTranslation } from 'react-i18next'

interface ViewOptionsPopoverProps {
  children: ReactNode
}

export function ViewOptionsPopover({ children }: ViewOptionsPopoverProps) {
  const { t } = useTranslation('common')
  return (
    <Popover.Root>
      <Popover.Trigger>
        <Button variant="outline" color="gray" size="2" radius="medium" aria-label={t('viewOptions')}>
          <MixerHorizontalIcon />
          {t('viewOptions')}
        </Button>
      </Popover.Trigger>
      <Popover.Content align="end" sideOffset={8} style={{ minWidth: 260 }}>
        <Flex direction="column" gap="3">
          {children}
        </Flex>
      </Popover.Content>
    </Popover.Root>
  )
}
